import {FormStructure} from 'etc/types';

export const CONTACT_FORM_STRUCTURE: FormStructure = {
  english_markets: ['fi', 'hu', 'il-he'],
  total_steps: 4,
  topics: {
    subscription: {
      topics: {
        charged_more_than_before: {
          show_chat_to_free_users: true,
          articles: [
            {
              id: '29564',
            },
            {
              id: '6155',
            },
          ],
        },
        question_about_trial: {
          show_chat_to_free_users: true,
          articles: [
            {
              id: '6162',
            },
            {
              id: '11681',
            },
            {
              id: '6816',
            },
            {
              id: '29345',
              markets: ['us'],
            },
          ],
        },
        how_upgrade_premium: {
          show_chat_to_free_users: true,
          articles: [
            {
              id: '6165',
            },
            {
              id: '6747',
            },
            {
              id: '10258',
            },
            {
              id: '6141',
            },
            {
              id: '6876',
            },
          ],
          self_help_banner: {
            self_help_premium: {
              url: 'https://www.spotify.com/premium',
            },
          },
        },
        unable_to_subscribe_payment_failed: {
          show_chat_to_free_users: true,
          articles: [
            {
              id: '6163',
            },
            {
              id: '6157',
            },
          ],
        },
        payment_methods_question: {
          show_chat_to_free_users: true,
          articles: [
            {
              id: '6157',
            },
            {
              id: '6163',
            },
          ],
          self_help_banner: {
            self_help_payments: {
              url: 'https://www.spotify.com/account/',
            },
          },
        },
        cancel_spotify_subscription: {
          articles: [
            {
              id: '6155',
            },
          ],
          self_help_banner: {
            self_help_cancelation_flow: {
              url: 'https://www.spotify.com/account/cancel/',
            },
          },
          form: {
            fields: {
              cancellation_reason: {},
            },
          },
        },
        permanently_close_spotify_account: {},
        cancelled_subscription_still_charged: {
          articles: [
            {
              id: '6155',
            },
            {
              id: '6704',
            },
          ],
          self_help_banner: {
            self_help_subscription: {
              url: 'https://www.spotify.com/account/subscription/',
            },
          },
          form: {
            fields: {
              payment_method: {visible_logged_in: true},
              spotify_partner: {visible_logged_in: true},
              other_email_addresses: {},
              facebook_email: {},
              other_usernames: {},
            },
          },
        },
        premium_not_working: {
          show_chat_to_free_users: true,
          articles: [
            {
              id: '10258',
            },
            {
              id: '7439',
            },
          ],
          self_help_banner: {
            self_help_premium_status: {
              url: 'https://www.spotify.com/account',
            },
          },
          form: {
            fields: {
              payment_method: {visible_logged_in: true},
              spotify_partner: {visible_logged_in: true},
              other_email_addresses: {},
              facebook_email: {},
              other_usernames: {},
            },
          },
        },
        charged_twice: {
          show_chat_to_free_users: true,
          articles: [
            {
              id: '29564',
            },
            {
              id: '6163',
            },
          ],
          form: {
            fields: {
              payment_method: {visible_logged_in: true},
              spotify_partner: {visible_logged_in: true},
              other_email_addresses: {},
              facebook_email: {},
              other_usernames: {},
            },
          },
        },
        spotify_family_question: {
          show_chat_to_free_users: true,
          articles: [
            {
              id: '27699',
            },
            {
              id: '27727',
            },
          ],
          self_help_banner: {
            self_help_premium_family: {
              url: 'https://www.spotify.com/account/family',
            },
          },
        },
        spotify_duo_question: {
          show_chat_to_free_users: true,
          markets: ['co', 'cl', 'ie', 'pl', 'dk'],
          articles: [
            {
              id: '24740',
            },
          ],
          self_help_banner: {
            self_help_premium_duo: {
              url: 'https://www.spotify.com/account/duo',
            },
          },
        },
        student_discount_question: {
          show_chat_to_free_users: true,
          articles: [
            {
              id: '8130',
            },
          ],
          self_help_banner: {
            self_help_premium_student: {
              url: 'https://www.spotify.com/student',
            },
          },
        },
        other: {
          articles: [
            {
              id: '7020',
            },
            {
              id: '9625',
              markets: ['uk'],
            },
            {
              id: '23353',
              markets: ['us'],
            },
            {
              id: '6229',
            },
            {
              id: '5411',
            },
          ],
        },
      },
    },
    account: {
      topics: {
        change_account_details: {
          show_chat_to_free_users: true,
          articles: [
            {
              id: '8871',
            },
            {
              id: '8095',
            },
            {
              id: '5185',
            },
            {
              id: '9499',
            },
            {
              id: '6158',
            },
          ],
          self_help_banner: {
            self_help_account_details: {
              url: 'https://www.spotify.com/account/',
            },
          },
        },
        cancel_spotify_subscription: {
          articles: [
            {
              id: '6155',
            },
          ],
          self_help_banner: {
            self_help_cancelation_flow: {
              url: 'https://www.spotify.com/account/cancel/',
            },
          },
          form: {
            fields: {
              cancellation_reason: {},
            },
          },
        },
        permanently_close_spotify_account: {},
        have_facebook_created_account: {
          articles: [
            {
              id: '7261',
            },
          ],
        },
        spotify_family_question: {
          show_chat_to_free_users: true,
          articles: [
            {
              id: '27699',
            },
          ],
          self_help_banner: {
            self_help_premium_family: {
              url: 'https://www.spotify.com/account/family',
            },
          },
        },
        other: {
          articles: [
            {
              id: '5407',
            },
            {
              id: '7439',
            },
            {
              id: '14985',
            },
            {
              id: '17371',
            },
          ],
        },
      },
    },
    logging_in: {
      topics: {
        can_not_log_in: {
          articles: [
            {
              id: '5407',
            },
            {
              id: '6166',
            },
            {
              id: '7439',
            },
            {
              id: '14985',
            },
            {
              id: '17371',
            },
          ],
          form: {
            fields: {
              subscription_type: {
                visible_logged_in: true,
              },
              subscription_type_banner: {
                visible_logged_in: true,
              },
            },
          },
        },
        trouble_resetting_password: {
          articles: [
            {
              id: '6166',
            },
          ],
          self_help_banner: {
            self_help_reset_password: {
              url: 'https://www.spotify.com/password-reset/',
            },
          },
        },
        account_takeover: {
          articles: [
            {
              id: '14985',
            },
          ],
        },
        have_facebook_created_account: {
          articles: [
            {
              id: '7261',
            },
          ],
        },
        other: {
          articles: [
            {
              id: '5407',
            },
            {
              id: '7439',
            },
            {
              id: '14985',
            },
            {
              id: '17371',
            },
            {
              id: '6206',
            },
          ],
        },
      },
    },
    technical_issues: {
      topics: {
        spotify_connect_trouble: {
          show_chat_to_free_users: true,
          articles: [
            {
              id: '6168',
            },
            {
              id: '23046',
            },
            {
              id: '22943',
            },
            {
              id: '22944',
            },
          ],
        },
        offline_mode_trouble: {
          show_chat_to_free_users: true,
          articles: [
            {
              id: '6169',
            },
            {
              id: '14748',
            },
          ],
          self_help_banner: {
            self_help_reset_offline_devices: {
              url: 'https://www.spotify.com/account/offline-devices/',
            },
          },
        },
        playlists_disappeared: {
          articles: [
            {
              id: '8149',
            },
            {
              id: '6768',
            },
            {
              id: '6827',
            },
          ],
          self_help_banner: {
            self_help_recover_playlists: {
              url: 'https://www.spotify.com/account/recover-playlists/',
            },
          },
          form: {
            fields: {
              missing_since_date: {
                type: 'select',
                options: ['today', 'yesterday', 'this_week', 'last_week', 'long_ago', 'dont_know'],
                required: true,
                placeholder: true,
                order: 1250,
                help_text: true,
              },
            },
          },
        },
        trouble_with_car_or_home_stereo: {
          show_chat_to_free_users: true,
          articles: [
            {
              id: '23046',
            },
            {
              id: '22943',
            },
            {
              id: '22944',
            },
            {
              id: '17593',
            },
            {
              id: '5350',
            },
            {
              id: '9732',
            },
            {
              id: '5127',
            },
            {
              id: '10025',
            },
          ],
        },
        spotify_not_working: {
          articles: [
            {
              id: '7679',
            },
            {
              id: '4886',
            },
          ],
        },
        other: {
          articles: [
            {
              id: '28977',
            },
            {
              id: '5578',
            },
            {
              id: '6210',
            },
            {
              id: '28100',
            },
          ],
        },
      },
    },
    ideas_feedback: {
      total_steps: 2,
      excluded_markets: ['jp'],
    },
    report_broken_song_or_information: {
      total_steps: 3,
      disable_chat: true,
      articles: [
        {
          id: '6177',
        },
      ],
      form: {
        fields: {
          song_uri: {
            type: 'text',
            placeholder: true,
            order: 1250,
            help_text: true,
          },
        },
      },
    },
    report_violating_content: {
      total_steps: 3,
      self_help_banner: {
        content_policy_text: {
          url: 'https://artists.spotify.com/faq/music#what-content-is-prohibited-on-spotify',
        },
      },
      form: {
        fields: {
          song_uri: {
            type: 'text',
            placeholder: true,
            order: 1250,
            help_text: true,
          },
        },
      },
    },
    privacy: {
      topics: {
        privacy_rights: {
          show_chat_to_free_users: true,
          articles: [
            {
              id: '21661',
            },
          ],
          self_help_banner: {
            privacy_rights_self_help: {
              url: 'https://www.spotify.com/privacy',
            },
          },
        },
        privacy_update_info: {
          show_chat_to_free_users: true,
          articles: [
            {
              id: '8095',
            },
            {
              id: '29561',
            },
            {
              id: '5185',
            },
          ],
          self_help_banner: {
            privacy_update_self_help: {
              url: 'https://www.spotify.com/account/profile/',
            },
          },
        },
        privacy_download: {
          show_chat_to_free_users: true,
          articles: [
            {
              id: '21661',
            },
          ],
          self_help_banner: {
            privacy_download_self_help: {
              url: 'https://www.spotify.com/account/privacy/',
            },
          },
        },
        privacy_delete: {
          total_steps: 3,
          articles: [
            {
              id: '21661',
            },
          ],
          hide_contact_form: true,
          self_help_banner: {
            privacy_delete_self_help: {
              url: 'https://support.spotify.com/account_payment_help/account_help/close-account/',
            },
          },
        },
      },
    },
  },
  form: {
    always_included_fields: [
      'subscription_type',
      'subscription_type_banner',
      'payment_method',
      'spotify_partner',
      'contact_phone',
      'contact_email',
      'display_name',
      'question',
    ],
    fields: {
      subscription_type: {
        type: 'select',
        options: ['free', 'trial', 'premium'],
        required: true,
        placeholder: true,
        visible_logged_in: false,
        order: 100,
      },
      subscription_type_banner: {
        type: 'banner',
        order: 105,
        visible_logged_in: false,
        title: 'security_important_for_us',
        content: 'screenshot_or_receipt',
        depends_on: {
          field: 'subscription_type',
          for_values: ['trial', 'premium'],
        },
      },
      payment_method: {
        type: 'select',
        options: [
          'paypal',
          'credit_card',
          'american_express',
          'klarna',
          'sofort',
          'itunes',
          'partner',
          'na',
          'dont_know',
        ],
        required: true,
        placeholder: true,
        visible_logged_in: false,
        order: 110,
        help_text: true,
        depends_on: {
          field: 'subscription_type',
          for_values: ['trial', 'premium'],
        },
      },
      spotify_partner: {
        type: 'select',
        options: [
          'base',
          'chess',
          'halebop',
          'hi',
          'jim_mobile',
          'kpn',
          'netcom',
          'orange',
          'sfr',
          'telekom',
          'telia',
          'virgin',
          'vodafone',
          'xs4all',
          'yoigo',
        ],
        required: true,
        placeholder: true,
        visible_logged_in: false,
        order: 120,
        depends_on: {
          field: 'payment_method',
          for_values: ['partner'],
        },
      },
      contact_phone: {
        type: 'phone',
        visible_logged_in: false,
        required: false,
        placeholder: true,
        order: 1050,
        markets: ['in'],
        overrides: [
          {
            match_all: ['market:in', 'chat', 'logged_out'],
            data: {
              required: true,
              required_with: 'contact_email',
            },
          },
        ],
      },
      contact_email: {
        type: 'email',
        visible_logged_in: false,
        required: true,
        placeholder: true,
        order: 1100,
        maxlength: 80,
        overrides: [
          {
            match_all: ['market:in'],
            data: {
              labelOverride: 'Email',
            },
          },
          {
            match_all: ['market:in', 'chat', 'logged_in'],
            data: {
              required: false,
            },
          },
          {
            match_all: ['market:in', 'chat', 'logged_out'],
            data: {
              required: true,
              required_with: 'contact_phone',
            },
          },
        ],
      },
      other_email_addresses: {
        type: 'text',
        help_text: true,
        order: 1140,
      },
      facebook_email: {
        type: 'email',
        placeholder: true,
        help_text: true,
        order: 1150,
      },
      other_usernames: {
        type: 'text',
        help_text: true,
        placeholder: true,
        order: 1160,
      },
      cancellation_reason: {
        type: 'radio',
        options: [
          'not_listening_to_music_enough_to_pay_for_premium',
          'rather_switch_to_free',
          'trying_to_save_money',
          'spotify_premium_does_not_include_all_the_features',
          'can_not_find_all_favorite_music',
          'technical_problem_need_help_to_solve',
          'switch_payment_method',
          'traveling_moving_abroad',
        ],
        required: true,
        order: 1250,
        help_text: true,
      },
      display_name: {
        type: 'text',
        required: true,
        order: 1350,
      },
      question: {
        type: 'textarea',
        required: true,
        order: 1400,
        placeholder: true,
        overrides: [
          {
            match_all: ['chatbot'],
            data: {
              labelOverride: 'Describe your issue in a few words',
              placeholderOverride: 'Example: I’m trying to get Premium but my payment isn’t working',
              maxlength: 120,
            },
          },
        ],
      },
    },
  },
};
